export const getHoldersTableData = async (coin: string) => {
    try {
        const res = await fetch(`/api/coin-data/holders-table-data?coin=${coin}`);
        const { holdersTableData } = await res.json();
        return  holdersTableData;
    } catch (error) {
        console.error(error);
    }
}